import { useState, useEffect } from 'react';
import { useCart } from '../../hooks/useCart';
import { Link } from 'react-router-dom';
import { getProductImage } from '../../utils/imageStorage';
import LocalImageUploader from '../../components/feature/LocalImageUploader';

export default function ProduitBougieLivrePlieSansLedV2() {
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const productId = 'bougie-sans-led';
  const defaultImage = 'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/b25886b6d5302fa4fce5dc966e858d39.png';
  const [productImage, setProductImage] = useState<string>(defaultImage);
  const [showImageUploader, setShowImageUploader] = useState(false);

  const product = {
    id: 'bougie-livre-plie-sans-led-v2',
    name: 'Bougie en livre plié – Sans LED V2',
    price: 30,
    originalPrice: null,
    images: [
      'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/b25886b6d5302fa4fce5dc966e858d39.png'
    ],
    description:
      "Nouvelle version de notre bougie décorative réalisée à partir d'un véritable livre ancien plié à la main. Version classique avec bougie traditionnelle. Chaque pièce est unique et ornée d'un ruban délicat. Une création poétique qui apporte une touche chaleureuse à votre intérieur.",
    features: [
      'Fait main à partir de livres anciens',
      'Bougie traditionnelle incluse',
      'Nouvelle version améliorée',
      'Chaque pièce est unique',
      "Ornée d'un ruban délicat", // escaped apostrophe
      'Création artisanale française',
      'Parfait pour la décoration de Noël'
    ],
    category: 'Collection de Noël',
    subcategory: 'Bougies en livres pliés'
  };

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleAddToCart = () => {
    try {
      addToCart(
        {
          id: product.id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          description: product.description,
          link: `/produit-bougie-livre-plie-sans-led-v2`
        },
        quantity
      );

      // Feedback visuel
      const button = document.querySelector('.add-to-cart-btn') as HTMLButtonElement;
      if (button) {
        const originalText = button.innerHTML;
        button.innerHTML = '<i class="ri-check-line mr-2"></i>Ajouté au panier !';
        button.disabled = true;
        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
        }, 2000);
      }
    } catch (err) {
      console.error('Erreur lors de l\'ajout au panier :', err);
      // Optionally, display a user‑friendly message
    }
  };

  useEffect(() => {
    const loadImage = async () => {
      const savedImage = await getProductImage(productId);
      if (savedImage) {
        setProductImage(savedImage);
      }
    };
    loadImage();
  }, []);

  const handleImageUpdate = (newImageUrl: string) => {
    setProductImage(newImageUrl || defaultImage);
    setShowImageUploader(false);
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-[#F8EDEA]">
      {/* Breadcrumb */}
      <div className="bg-[#FAF9F8] py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-[#B97A72] hover:text-[#C49B86]">
              Accueil
            </Link>
            <i className="ri-arrow-right-s-line text-[#6B5E5A]"></i>
            <Link to="/boutique" className="text-[#B97A72] hover:text-[#C49B86]">
              Boutique
            </Link>
            <i className="ri-arrow-right-s-line text-[#6B5E5A]"></i>
            <span className="text-[#6B5E5A]">{product.name}</span>
          </nav>
        </div>
      </div>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Image du produit */}
            <div>
              <div className="w-full h-[500px] bg-white rounded-lg overflow-hidden shadow-lg mb-4">
                <img
                  src={productImage}
                  alt="Bougie en livre plié — Sans LED"
                  className="w-full h-full object-contain"
                />
              </div>
              
              {/* Bouton pour modifier l'image */}
              <div className="text-center">
                <button
                  onClick={() => setShowImageUploader(!showImageUploader)}
                  className="bg-[#B97A72] text-white px-6 py-3 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  <i className="ri-image-edit-line mr-2"></i>
                  {showImageUploader ? 'Fermer' : '📸 Modifier l\'image'}
                </button>
              </div>

              {/* Module de changement d'image */}
              {showImageUploader && (
                <div className="mt-6 bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="text-xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                    Modifier l'image du produit
                  </h3>
                  <LocalImageUploader
                    productId={productId}
                    currentImage={productImage}
                    onImageUpdate={handleImageUpdate}
                  />
                </div>
              )}
            </div>

            {/* Informations produit */}
            <div className="space-y-6">
              <div>
                <span
                  className="text-sm text-[#B97A72] font-medium"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {product.subcategory}
                </span>
                <h1
                  className="text-4xl font-bold text-[#6B5E5A] mt-2"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {product.name}
                </h1>
                <div className="mt-2">
                  <span className="bg-[#C49B86] text-white px-3 py-1 rounded-full text-sm font-medium">
                    Version 2
                  </span>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <span
                  className="text-3xl font-bold text-[#B97A72]"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {product.price}€
                </span>
                {product.originalPrice && (
                  <span className="text-xl text-[#6B5E5A] line-through">
                    {product.originalPrice}€
                  </span>
                )}
              </div>

              <p
                className="text-[#6B5E5A] leading-relaxed"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                {product.description}
              </p>

              {/* Caractéristiques */}
              <div className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg p-6">
                <h3
                  className="text-lg font-semibold text-[#6B5E5A] mb-4"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  Caractéristiques
                </h3>
                <ul className="space-y-2">
                  {product.features.map((feature, index) => (
                    <li
                      key={index}
                      className="flex items-center text-[#6B5E5A]"
                      style={{ fontFamily: 'Poppins, sans-serif' }}
                    >
                      <i className="ri-check-line text-[#B97A72] mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Quantité et ajout au panier */}
              <div className="space-y-4">
                <div>
                  <label
                    className="block text-sm font-medium text-[#6B5E5A] mb-2"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    Quantité
                  </label>
                  <div className="flex items-center space-x-3">
                    <button
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      className="w-10 h-10 flex items-center justify-center border-2 border-[#B97A72] text-[#B97A72] rounded-lg hover:bg-[#B97A72] hover:text-white transition-colors"
                    >
                      <i className="ri-subtract-line"></i>
                    </button>
                    <span className="text-xl font-semibold text-[#6B5E5A] min-w-[3rem] text-center">
                      {quantity}
                    </span>
                    <button
                      onClick={() => setQuantity(quantity + 1)}
                      className="w-10 h-10 flex items-center justify-center border-2 border-[#B97A72] text-[#B97A72] rounded-lg hover:bg-[#B97A72] hover:text-white transition-colors"
                    >
                      <i className="ri-add-line"></i>
                    </button>
                  </div>
                </div>

                <button
                  onClick={handleAddToCart}
                  className="add-to-cart-btn w-full bg-[#B97A72] text-white py-4 rounded-lg hover:bg-[#C49B86] transition-colors text-lg font-medium whitespace-nowrap"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  <i className="ri-shopping-cart-line mr-2"></i>
                  Ajouter au panier
                </button>
              </div>

              {/* Informations de livraison */}
              <div className="bg-[#EBD2CF] rounded-lg p-4">
                <div className="flex items-center space-x-3 text-[#6B5E5A]">
                  <i className="ri-truck-line text-[#B97A72]"></i>
                  <span className="text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Livraison gratuite à partir de15 € d'achat
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Produits similaires */}
      <div className="mt-16">
        <h2
          className="text-3xl font-bold text[#B97A72] mb-8 text-center"
          style={{ fontFamily: 'Allura, cursive' }}
        >
          Vous pourriez aussi aimer
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              id: 'bougie-avec-led',
              name: 'Bougie en livre plié – Avec LED',
              price: 30,
              image:
                'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/842983f7d1219d4e05abdf64e978f33f.png',
              link: '/produit-bougie-livre-plie-avec-led'
            },
            {
              id: 'sapin-noel',
              name: 'Sapin de Noël en livre plié',
              price: 30,
              image:
                'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/b25886b6d5302fa4fce5dc966e858d39.png',
              link: '/produit-sapin-noel-livre-plie'
            },
            {
              id: 'ange-joyeux-coeur',
              name: 'Ange "Joyeux Cœur"',
              price: 4,
              image:
                'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/9ca0f2dee5922ad907a452879600467c.png',
              link: '/produit-ange-joyeux-coeur'
            }
          ].map(relatedProduct => (
            <Link
              key={relatedProduct.id}
              to={relatedProduct.link}
              className="bg[#FAF9F8] border-2 border[#B97A72] rounded-lg overflow-hidden hover:shadow-lg transition-shadow group"
            >
              <div className="aspect-square bg[#F3D9D9] overflow-hidden">
                <img
                  src={relatedProduct.image}
                  alt={relatedProduct.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4">
                <h3
                  className="font-semibold text[#6B5E5A] mb-2"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {relatedProduct.name}
                </h3>
                <span
                  className="text-xl font-bold text[#B97A72]"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {relatedProduct.price}€
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
